const state = {
    downloads_all: [],
    downloads_kunde: [],
    uploads_kunde: [],
    anfragen_kunde: [],
    categories: [],
    updating: {
        downloads: false,
        downloads_all: false,
        uploads: false,
        anfragen: false,
        categories: false,
    },
    ready: {
        downloads: false,
        downloads_all: false,
        uploads: false,
        anfragen: false,
        categories: false,
    }
}

const getters = {
    downloads_all: (state) => state.downloads_all,
    downloads_kunde: (state) => state.downloads_kunde,
    uploads_kunde: (state) => state.uploads_kunde,
    categories: (state) => state.categories,
    anfragen_kunde: (state) => state.anfragen_kunde,
    updating: (state) => state.updating,
    ready: (state) => state.ready,
}

const actions = {
    async getDownloadsOfKunde({
        commit
    }, kundeId) {
        const query = {
            fields: "*.*.*",
            filter: {
                kunde_id: kundeId
            },
        }
        try {
            const response = await this._vm.$directus.getItems("download_kunde", query);
            commit("setDownloadsKunde", response.data);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Kundendownloads";
        }
    },
    async getUploadsOfKunde({
        commit
    }, kundeId) {
        const query = {
            fields: "*.*.*",
            filter: {
                kunde: kundeId
            }
        }
        try {
            const response = await this._vm.$directus.getItems("upload", query);
            commit("setUploadsKunde", response.data);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Kundenuploads"
        }

    },
    async getCategories({
        commit
    }) {
        const fields = {
            fields: "*.*"
        }
        try {
            commit("setUpdateState", "categories");
            const response = await this._vm.$directus.getItems("media_categories", fields);
            if (response.data.length) commit("setCategories", response.data);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Kategorien";
        } finally {
            commit("unsetUpdateState", "categories");
            commit("setReadyState", "categories");
        }
    },
    async addCategory(_, payload) {
        try {
            const response = await this._vm.$directus.createItem("media_categories", payload);
            console.log("createCategory response");
            console.log(response);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen der Kategorie";
        }
    },
    async getAllDownloads({
        commit
    }) {
        const fields = {
            fields: "*.*.*"
        }

        try {
            commit("setUpdateState", "downloads_all");
            const response = await this._vm.$directus.getItems("download", fields);

            if (response.data.length) commit("setDownloadsAll", response.data);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Laden der Downloads";
        } finally {
            commit("unsetUpdateState", "downloads_all");
            commit("setReadyState", "downloads_all");
        }
    },
    async newDownload(_, payload) {
        try {
            const responseDownload = await this._vm.$directus.createItem("download", payload.download);
            const payloadRelation = {
                kunde_id: payload.kunde.kunde_id,
                download_id: responseDownload.data.id
            }
            await this._vm.$directus.createItem("download_kunde", payloadRelation);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen des Downloads";
        }
    },
    async removeDownloadAssignment(_, relId) {
        try {
            await this._vm.$directus.deleteItem("download_kunde", relId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Aufheben der Downloadzuordnung";
        }
    },
    async newUpload(_, payload) {
        try {
            const responseUpload = await this._vm.$directus.createItem("upload", payload);
            console.log(responseUpload);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen des Uploads"
        }
    },
    async deleteCategory(_, catId) {
        try {
            await this._vm.$directus.deleteItem("media_categories", catId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Entfernen der Kategorie";
        }
    },
    async deleteDownload(_, dlId) {
        try {
            await this._vm.$directus.deleteItem("download", dlId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Entfernen des Downloads.";
        }
    },
    async deleteUpload(_, upId) {
        try {
            await this._vm.$directus.deleteItem("upload", upId);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Entfernen des Uploads";
        }
    }
}

const mutations = {
    setDownloadsKunde: (state, downloads) => state.downloads_kunde = downloads,
    setUploadsKunde: (state, uploads) => state.uploads_kunde = uploads,
    setAnfragenKunde: (state, anfragen) => state.anfragen_kunde = anfragen,
    setDownloadsAll: (state, downloads) => state.downloads_all = downloads,
    setCategories: (state, categories) => state.categories = categories,
    setReadyState: (state, resource) => {
        switch (resource) {
            case "categories":
                state.ready.categories = true;
                break;
            case "downloads":
                state.ready.downloads = true;
                break;
            case "uploads":
                state.ready.uploads = true;
                break;
            case "downloads_all":
                state.ready.downloads_all = true;
                break;
            case "anfragen":
                state.ready.anfragen = true;
                break;
        }
    },
    unsetReadyState: (state, resource) => {
        switch (resource) {
            case "categories":
                state.ready.categories = false;
                break;
            case "downloads":
                state.ready.downloads = false;
                break;
            case "uploads":
                state.ready.uploads = false;
                break;
            case "downloads_all":
                state.ready.downloads_all = false;
                break;
            case "anfragen":
                state.ready.anfragen = false;
                break;
        }
    },
    setUpdateState: (state, resource) => {
        switch (resource) {
            case "categories":
                state.updating.categories = true;
                break;
            case "downloads":
                state.updating.downloads = true;
                break;
            case "uploads":
                state.updating.uploads = true;
                break;
            case "downloads_all":
                state.updating.downloads_all = true;
                break;
            case "anfragen":
                state.updating.anfragen = true;
                break;
        }
    },
    unsetUpdateState: (state, resource) => {
        switch (resource) {
            case "categories":
                state.updating.categories = false;
                break;
            case "downloads":
                state.updating.downloads = false;
                break;
            case "uploads":
                state.updating.uploads = false;
                break;
            case "downloads_all":
                state.updating.downloads_all = false;
                break;
            case "anfragen":
                state.updating.anfragen = false;
                break;
        }

    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};